import { render, staticRenderFns } from "./Playlists.vue?vue&type=template&id=375d384e"
import script from "./Playlists.vue?vue&type=script&lang=js"
export * from "./Playlists.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports